import React from 'react';
import {Field, FieldArray, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//import components
import AdvancedSearchFormSelectAttr from './AdvancedSearchFormSelectAttr.js';
import AdvancedSearchFormInnerfield from './AdvancedSearchFormInnerfield.js';

//img
import plusImg from '../../assets/icons/plus.svg'
import plusImgContrast from '../../assets/icons/plus-contrast.svg'

const AdvancedSearchFormFieldset = ({ fields, change, innerFieldsVal, attributeFieldVal, optionData, meta: { error, submitFailed }, clang, getRelation, conjOptions, getAllRelations }) => {
    const isLoggedIn = localStorage.getItem('user');

    const getNewOptionData = (index) => {
        return optionData.filter((option, optionIndex) => (
                  attributeFieldVal.length === 0 ||
                  attributeFieldVal.filter((attr, attrIndex) => attr.value === option.value).length < 1 ||
                  (attributeFieldVal.filter((attr, attrIndex) => attr.value === option.value).length <= 1 && attributeFieldVal[index] && attributeFieldVal[index].value === option.value)) &&
                  (isLoggedIn || option.unloggedVisible));
    };

    const addNewField = () => {
        fields.push({
            attribute: getNewOptionData(attributeFieldVal.length)[0],
            innerFields: [{relation: getRelation(getNewOptionData(attributeFieldVal.length)[0].type)}]
        });
    };

    const removeField = (index) => {
        fields.remove(index);
    };

    const onAttributeChange = (val, query, fieldsIndex) => {
        innerFieldsVal[`${fieldsIndex}`].map((elem, index) =>  change(`${query}.innerFields[${index}].relation`, getRelation(val.type)));
        change(`${query}.innerFields[0].value`, "");
        change(`${query}.innerFields[0].valueTo`, "");
        change(`${query}.innerFields[0].valueFrom`, "");
    };

    return (
        <ul className="advanced-search__form-list">
            {fields.map((query, index) =>
                getNewOptionData(index).length > 0 &&
                    <div key={index}>
                    {index !== 0 &&
                        <li className="advanced-search__form-list__item--and">
                            <span>{lang[clang].advanced_search.and}</span>
                        </li>}
                    <li key={index} className="advanced-search__form-list__item">
                        {fields.length > 1 &&
                            <button type="button"
                                title={lang[clang].advanced_search.remove_fields}
                                onClick={() => removeField(index)}
                                className="advanced-search__item__remove">
                                <span className="advanced-search__item__remove-icon"></span>
                            </button>}
                        <div className="advanced-search__item--left">
                            <Field component={AdvancedSearchFormSelectAttr} name={`${query}.attribute`}
                                onChange={(val) => onAttributeChange(val, query, index)}
                                placeholder={lang[clang].advanced_search.select_attribute}
                                label={lang[clang].advanced_search.search_field}
                                props={{
                                    options: getNewOptionData(index)
                                }} />
                        </div>
                        <div className="advanced-search__item--right">
                            <FieldArray name={`${query}.innerFields`} component={AdvancedSearchFormInnerfield}
                                getRelation={getRelation}
                                getAllRelations={getAllRelations}
                                change={change}
                                conjOptions={conjOptions}
                                attributeFieldVal={attributeFieldVal[index].type}
                                attributeFieldVals={attributeFieldVal[index].values}/>
                        </div>
                    </li>
                    </div>)}
                {attributeFieldVal.length !== optionData.length &&
                    <li className="advanced-search__form-list__item--add">
                        <button type="button" onClick={() => addNewField()} className="advanced-search__form-list__item--add__button">
                            <div className="advanced-search__button--dark"
                                title={lang[clang].advanced_search.add_fields}>
                                <img src={plusImg} className="advanced-search__button--light__img" alt="" />
                                <img src={plusImg} className="advanced-search__button--light__img--light" alt="" />
                                <img src={plusImgContrast} className="advanced-search__button--light__img contrast" alt="" />
                            </div>
                            <span className="advanced-search__add">{lang[clang].advanced_search.add_fields}</span>
                        </button>
                        {submitFailed && error && <span>{lang[clang].validation[error]}</span>}
                    </li>}
        </ul>
    );
};

AdvancedSearchFormFieldset.propTypes = {
    clang: propTypes.string.isRequired,
    attributeFieldVal: propTypes.array.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const selector = formValueSelector(ownProps.meta.form);
    const getFieldSelector = (name) => selector(state, `${name}.attribute`);
    const getInnerFieldsSelector = (name) => selector(state, `${name}.innerFields`);

    return {
        clang: state.language.currentLanguage,
        //get updated field value from store
        attributeFieldVal: ownProps.fields.getAll().map((e, index) => getFieldSelector(`${ownProps.fields.name}[${index}]`)),
        innerFieldsVal: ownProps.fields.getAll().map((e, index) => getInnerFieldsSelector(`${ownProps.fields.name}[${index}]`)),
    }
};

export default connect(mapStateToProps)(AdvancedSearchFormFieldset);



// WEBPACK FOOTER //
// ./src/components/advanced-search/AdvancedSearchFormFieldset.js